<template>
    <div>
        <div class="member-panel__text">
            <p class="member-panel__headline">Hej {{ member.firstName }}!</p>
            <p>{{dictionary.memberNavigationText}}</p>
        </div>
        <nav class="member-panel__navigation">
            <ul>
                <li v-for="item in navigationItems" :key="item.url"><a :href="item.url">{{ item.title }}</a></li>
            </ul>
        </nav>
        <Button @click="logOutMember">Log ud</Button>
    </div>
</template>
<script>

import Button from 'primevue/button';
export default {
    name: "memberMainNavigation",
    props: ['member','dictionary'],
    components: {
        Button
    },
    data() {
        return {
            navigationItems:[]
        };
    },
    created() {
        const vm = this;
        fetch("/umbraco/api/memberApi/GetMemberNavigationItems").then((response) => response.json())
            .then((data) => {
                vm.navigationItems = data;
            })
            .catch((error) => {
                console.log(error);
            });
    },
    validations() {
        return {
            member: {
                email: { required, email },
                password: {
                    required,
                    minLengthValue: minLength(10),
                }
            }

        }
    },
    methods: {
        logOutMember() {
            const vm = this;
            fetch('/umbraco/api/memberapi/LogOutMember')
                .then(data => {
                    vm.$emit("loggedOut");
                }).catch(error => {
                    vm.$toast.add({ severity: 'error', summary: vm.dictionary.memberGeneralErrorTitle, detail: vm.dictionary.memberGeneralErrorText, life: 10000 });
                    console.log(error);
                })
        }
    }
};
</script>
